module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("异步加载组件")]), _vm._v(" "), _c('p', [_vm._v("将所有页面组件一次性加载是一个很浪费资源和考验用户耐心的做法，尤其在移动端。")]), _vm._v(" "), _c('h2', [_vm._v("使用方法")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("webpack")]), _vm._v(" 提供了"), _c('a', {
    attrs: {
      "href": "https://webpack.js.org/guides/code-splitting-require/"
    }
  }, [_vm._v("code splitting")]), _vm._v("，你可以按照下面写法实现当切换到特定路由时才加载代码。")]), _vm._v(" "), _c('p', [_vm._v("需要注意的是 "), _c('code', [_vm._v("vue-loader@13.0.0")]), _vm._v(" 语法有所变更，具体参照发布说明 "), _c('a', {
    attrs: {
      "href": "https://github.com/vuejs/vue-loader/releases/tag/v13.0.0"
    }
  }, [_vm._v("v13.0.0")])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// vue-loader@13.0.0 之前")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("const")]), _vm._v(" Foo = "), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("()")]), _vm._v(" =>")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v("("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'./Foo.vue'")]), _vm._v(") "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 在 Vue 2.4 + vue-router 2.7 版本下可以正确运行")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// vue-loader@13.0.0")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("const")]), _vm._v(" Foo = "), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("()")]), _vm._v(" =>")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v("("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'./Foo.vue'")]), _vm._v(").then("), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("m")]), _vm._v(" =>")]), _vm._v(" m.default)\n")])]), _vm._v(" "), _c('h2', [_vm._v("组件打包问题")]), _vm._v(" "), _c('p', [_vm._v("如果你在不同的进行了代码分割的 .vue 文件引入了相同的组件，在打包时两个路由的代码都会重复打包该组件。")]), _vm._v(" "), _c('p', [_vm._v("你可以对重复使用的组件在 "), _c('code', [_vm._v("main.js")]), _vm._v(" 进行全局注册，以减少相应 chunk file 的大小并提高下载速度。")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4120d964", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-4120d964"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/vue-webpack-code-splitting-async-171.vue
// module id = 2666
// module chunks = 217